import { RootState } from "@/redux/store";
import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const WelcomeUser = () => {
	const currentUser = useSelector((state: RootState) => state.user.user);

	return (
		<Stack direction="row" alignItems="center" className="bg-transparent">
			<Stack alignContent={"center"} alignSelf={"center"}>
				<Typography className="!font-montserrat font-medium text-neutral-gray !leading-[1.2]">Welcome back</Typography>
			</Stack>
			<Stack alignContent={"center"} alignSelf={"center"}>
				<Typography className="[font-variant:small-caps] pl-4 !font-semibold !text-[106%] !font-montserrat text-medium-pink ">
					{currentUser?.fullName}
				</Typography>
			</Stack>
		</Stack>
	);
};

export default WelcomeUser;
